// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5h-VF","option":"styles_option__1MJy6","active":"styles_active__mA4Uf"};